import { render, staticRenderFns } from "./DevicePrice.vue?vue&type=template&id=35314d7a&scoped=true"
import script from "./DevicePrice.vue?vue&type=script&lang=ts"
export * from "./DevicePrice.vue?vue&type=script&lang=ts"
import style0 from "./DevicePrice.vue?vue&type=style&index=0&id=35314d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35314d7a",
  null
  
)

export default component.exports